import React, { useState, useEffect, useRef } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/css";

function MbtiSelector({ mbti, onSelect }) {
	// MBTI 类型列表
	const mbtiTypes = [
		"enfj",
		"enfp",
		"entj",
		"entp",
		"esfj",
		"esfp",
		"estj",
		"estp",
		"infj",
		"infp",
		"intj",
		"intp",
		"isfj",
		"isfp",
		"istj",
		"istp",
	];

	const splideRef = useRef(null);
	const [selectedIndex, setSelectedIndex] = useState(0);

	// 获取当前选中的MBTI索引
	useEffect(() => {
		if (mbti) {
			const index = mbtiTypes.indexOf(mbti);
			if (index !== -1) {
				setSelectedIndex(index);
				if (splideRef.current) {
					splideRef.current.go(index);
				}
			}
		}
	}, [mbti]);

	// 获取 MBTI 图片路径
	function getMbtiImage(mbtiType) {
		return require(`../../../asset/mbti/${mbtiType}.png`);
	}

	// 格式化 MBTI 显示名称
	function formatMbtiName(mbtiType) {
		return mbtiType.toUpperCase();
	}

	// 处理滑动事件
	const handleMoved = (splide, newIndex) => {
		setSelectedIndex(newIndex);
		onSelect(mbtiTypes[newIndex]);
	};

	return (
		<div className="relative w-80">
			<div
				className="absolute inset-y-0 w-1/4 h-full left-0 bg-gradient-to-r from-gray-50 via-gray-50/75 to-transparent z-10"></div>
			<div
				className="absolute inset-y-0 w-1/4 h-full right-0 bg-gradient-to-l from-gray-50 via-gray-50/75 to-transparent z-10"></div>
			<Splide
				ref={splideRef}
				options={{
					type: "loop",
					perPage: 3,
					focus: "center",
					arrows: true,
					pagination: false,
				}}
				onMoved={handleMoved}>
				{mbtiTypes.map((mbtiType, index) => (
					<SplideSlide key={mbtiType}>
						<div className="flex flex-col items-center overflow-hidden">
							<div
								className={`relative flex flex-col items-center justify-center gap-2 w-28 pt-3 h-auto cursor-pointer transition-all duration-100 ${
									index === selectedIndex ? "" : "opacity-60"
								}`}
								onClick={() => {
									if (splideRef.current) {
										splideRef.current.go(index);
									}
								}}>
								<img
									className="w-full h-full object-contain z-0"
									src={getMbtiImage(mbtiType)}
									alt={mbtiType}
								/>
								{/* MBTI Label */}
								<div className="text-center font-bold">
									{formatMbtiName(mbtiType)}
								</div>
							</div>
						</div>
					</SplideSlide>
				))}
			</Splide>

			<style jsx global>{`
				.splide__arrow {
					background: rgba(255, 255, 255, 0) !important;
					border-radius: 50%;
					width: 32px !important;
					height: 32px !important;
					opacity: 1 !important;
					border: none !important;
					z-index: 10 !important;
				}

				.splide__arrow:hover {
					// background: white !important;
					// transform: scale(1.1);
				}

				.splide__arrow svg {
					fill: #4b5563 !important;
					width: 16px !important;
					height: 16px !important;
				}

				.splide__arrow--prev {
					left: -8px !important;
				}

				.splide__arrow--next {
					right: -8px !important;
				}
			`}</style>
		</div>
	);
}

export default MbtiSelector;
